<template>
  <select-photo/>
</template>
<script>
import SelectPhoto from "../../components/base/select-photo/select-photo";
export default {
  components: { SelectPhoto },
  mounted() {
    //todo 处理个性化样式
    // document
    //   .querySelector("input[class='btn-info-submit']")
    //   .classList.add("br");
  }
};
</script>

<style lang="scss">
</style>
